import { useLocation, useHistory } from "react-router-dom";
import { useMemo, useCallback } from "react";

export function useSearchParams(defaultInit = {}) {
  const location = useLocation();
  const history = useHistory();

  const searchParams = useMemo(() => {
    const params = new URLSearchParams(location.search);
    Object.entries(defaultInit).forEach(([key, value]) => {
      if (!params.has(key)) params.set(key, value);
    });
    return params;
  }, [location.search, defaultInit]);

  const setSearchParams = useCallback(
    (nextParams, options = {}) => {
      const params = new URLSearchParams();

      Object.entries(nextParams).forEach(([key, value]) => {
        if (value == null || value === "undefined") return;
        if (Array.isArray(value)) {
          value.forEach((v) => params.append(key, v));
        } else if (value !== undefined && value !== null) {
          params.set(key, value);
        }
      });

      history[options.replace ? "replace" : "push"]({
        pathname: location.pathname,
        search: params.toString(),
      });
    },
    [history, location.pathname]
  );

  return [searchParams, setSearchParams];
}
